import React from 'react';
import { motion } from 'framer-motion';
import { Gift, MessageCircle, Eye, Headphones, Users } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: MessageCircle,
    title: 'Las 15 Frases Prohibidas',
    description: 'Las frases exactas que generan tensión emocional instantánea. No son "líneas de levante" — son disparadores psicológicos que cambian la dinámica de cualquier conversación.',
    value: 47
  }, {
    icon: Eye,
    title: 'Guía de Lenguaje Corporal Magnético',
    description: 'El 93% de la comunicación es no verbal. Esta guía te enseña a proyectar confianza, dominio y atracción sin decir una sola palabra.',
    value: 37
  }, {
    icon: Headphones,
    title: 'Audio: Mentalidad de Hombre Irresistible',
    description: 'Un audio de reprogramación mental diseñado para eliminar la inseguridad y construir la mentalidad que las mujeres encuentran magnética.',
    value: 29
  }, {
    icon: Users,
    title: 'Acceso al Grupo Privado VIP',
    description: 'Comunidad exclusiva de hombres que están aplicando el sistema. Compartí experiencias, recibí feedback y acelerá tus resultados.',
    value: 97
  }];
  const totalValue = bonuses.reduce((sum, b) => sum + b.value, 0);
  return <section className="py-20 sm:py-28 bg-primary relative overflow-hidden" data-id="element-1">
      {/* Gold ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/3 blur-[150px] rounded-full pointer-events-none" data-id="element-2" />

      <div className="max-w-4xl mx-auto px-5 sm:px-6 relative z-10" data-id="element-3">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-4">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/20 rounded-full px-5 py-2 mb-6" data-id="element-5">
            <Gift size={16} className="text-gold" data-id="element-6" />
            <span className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-7">
              Bonos exclusivos
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4" data-id="element-8">
            Solo por tiempo limitado
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto" data-id="element-9">
            Además del manual completo, hoy te llevás estos 4 bonos valorados en
            más de <span className="text-gold font-bold" data-id="element-10">${totalValue}</span> —
            totalmente gratis.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-5 mb-12" data-id="element-11">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col sm:flex-row items-start gap-5 p-6 bg-secondary rounded-xl border border-gold/10 hover:border-gold/25 transition-colors duration-300" data-id="element-12">
              {/* Icon thumbnail */}
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gold/10 rounded-xl flex items-center justify-center flex-shrink-0 border border-gold/15" data-id="element-13">
                <bonus.icon size={28} className="text-gold" data-id="element-14" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-15">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2" data-id="element-16">
                  <h3 className="text-lg sm:text-xl font-bold text-white" data-id="element-17">
                    {bonus.title}
                  </h3>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-18">
                    <span className="text-gray-500 line-through text-sm" data-id="element-19">
                      ${bonus.value}
                    </span>
                    <span className="bg-gold/15 text-gold text-xs font-black px-3 py-1 rounded-full border border-gold/20 uppercase" data-id="element-20">
                      Gratis
                    </span>
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-21">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-gold/10 via-gold/5 to-transparent rounded-xl border-2 border-gold/30 p-8 text-center" data-id="element-22">
          <p className="text-gray-400 text-sm uppercase tracking-widest mb-3" data-id="element-23">
            Valor total de los bonos
          </p>
          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-24">
            <span className="text-gray-500 line-through text-3xl sm:text-4xl font-bold" data-id="element-25">
              ${totalValue}
            </span>
            <span className="text-crimson text-lg font-black" data-id="element-26">→</span>
            <span className="text-gold text-4xl sm:text-5xl font-black" data-id="element-27">
              GRATIS
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-28">
            Incluidos con tu compra del Manual de Seducción Prohibida — solo
            hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}